/** Rough check that text is English, so the paraphraser can say "English only" instead of silently changing nothing. */
const EN = new Set("the a an and or but of to in on at for with is are was were be been it this that these those as by from not have has had will would can could i you he she we they my your his her our their".split(" "));

export function looksNonEnglish(text: string): boolean {
  const letters = Array.from(text).filter((c) => c.toLowerCase() !== c.toUpperCase() || c.charCodeAt(0) > 0x24f);
  if (letters.length < 12) return false;
  const nonLatin = letters.filter((c) => /[^\u0000-ɏ]/.test(c)).length;
  if (nonLatin / letters.length > 0.3) return true;
  const words = text.toLowerCase().match(/[a-z\u00c0-\u024f']+/g) ?? [];
  if (words.length < 6) return false;
  const hits = words.filter((w) => EN.has(w)).length;
  return hits / words.length < 0.08;
}
